/* ==========================================
   Premium Comparison Showcase
========================================== */

document.addEventListener("DOMContentLoaded", () => {

  const sections = document.querySelectorAll(".comparison-showcase");

  sections.forEach((section) => {

    const cards = section.querySelectorAll(".comparison-card");

    /* -----------------------------
       Fade Animation
    ------------------------------*/

    const observer = new IntersectionObserver((entries) => {

      entries.forEach((entry) => {

        if (entry.isIntersecting) {

          entry.target.classList.add("comparison-visible");

        }

      });

    }, {
      threshold: 0.15
    });

    cards.forEach(card => {

      card.classList.add("comparison-hidden");

      observer.observe(card);

    });

    /* -----------------------------
       Hover Glow
    ------------------------------*/

    cards.forEach(card => {

      card.addEventListener("mouseenter", () => {

        cards.forEach(c => c.classList.remove("active-card"));

        card.classList.add("active-card");

      });

      card.addEventListener("mouseleave", () => {

        card.classList.remove("active-card");

      });

    });

  });

});